export default __webpack_public_path__ + "static/photo1-61360469d5caa3d948d0d72fb2abef12.jpg";